import {
  RECOGNIZED_USER_INSUFFICIENT_DATA,
  RECOGNIZED_USER_SUFFICIENT_DATA,
  UNRECOGNIZED_USER
} from 'constants/personalizationMarkerTypes';

/* I know it looks silly that we are getting the PersonalizationMarker component
   as a parameter here and not being imported directly.
   Unfortunately, if we do that, Nightwatch (re: npm run test:e2e) will complain
   that the css and svgs imported by the component are not valid Javascript. Strange.
*/
export function makePersonalizationMarker({ PersonalizationMarker, isCustomerRecognized, isPersonalized, componentName, sourcePage, forcedAlignment, contents, onSigninClick, location }, hydraPersonalizationMarker) {
  if (!hydraPersonalizationMarker) {
    return null;
  }

  const { icon: markerAlignment, contents: contentsAlignment } = forcedAlignment || {};

  const iconAlignment = markerAlignment ? markerAlignment : (hydraPersonalizationMarker === 2 ? 'right' : 'left');

  let type = UNRECOGNIZED_USER;
  if (isCustomerRecognized) {
    type = isPersonalized ? RECOGNIZED_USER_SUFFICIENT_DATA : RECOGNIZED_USER_INSUFFICIENT_DATA;
  }

  return <PersonalizationMarker
    iconAlignment={iconAlignment}
    contentsAlignment={contentsAlignment}
    sourcePage={sourcePage}
    type={type}
    location={location}
    componentName={componentName}
    contents={contents}
    onSigninClick={onSigninClick}
  />;
}
